import React from 'react'
import { useForm } from "react-hook-form";
import { TextField, Button, Stack } from "@mui/material";

const SourcesForm = () => {

    const { register, handleSubmit, watch, formState: { errors }, handleChange, control } = useForm();

    const onSubmit = (data) => {
        console.log(data);
    }
    return (
        <>
            <div>


                <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete='off' >
                    <Stack spacing={2}>
                        <h1>Sources Form</h1>

                        <TextField name="source_id" label='Source id' {...register("source_id")} />
                        <TextField name="archive_name" label='Archive name' {...register("archive_name")} />

                        <TextField name="kennzeichnung" label='kennzeichnung' {...register("kennzeichnung")} />

                        <TextField name="link" label='Link' {...register("link")} />




                        <Button type='submit' variant="outlined">Submit</Button>

                    </Stack>

                </form>


            </div>
        </>
    )
}

export default SourcesForm